import React from "react";
import {
  GstrTwoADataType,
  GstrTwoAInvoiceDataType,
} from "../../../commonTypes/gstTypes";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { STATES_LIST_WITH_CODE } from "../../../constant/stateListConstants";
import { CollapseClose, CollapseOpen } from "../../../assets/images";
import ItemDataTable from "../GstTables/ItemDataTable";
import { GSTR2A2B_ITEM_HEADER } from "../../../constant/tableHeadersConstants/gst";

type AppProps = {
  data: GstrTwoADataType | GstrTwoADataType[] | [] | any;
  tableHeader: TableHeadersType[];
  setData: any;
  finalData: any;
  index: number;
  showMissingInvoices: boolean;
  handleCompareAddInvoice: (data: string,month:string) => void;
};

const GstrTwoATableData = ({
  data,
  tableHeader,
  setData,
  finalData,
  index,
  showMissingInvoices,
  handleCompareAddInvoice,
}: AppProps) => {
  const handleClick = (id: string, invoiceType: string) => {
    const updatedData = {
      ...data,
      data: {
        ...data.data,
        [invoiceType]: data.data[invoiceType].map(
          (invoice: GstrTwoAInvoiceDataType) => {
            if (invoice.invoice_number === id) {
              return { ...invoice, isOpen: !invoice.isOpen };
            }
            return invoice;
          }
        ),
      },
    };

    let updatedFinalData = [...finalData];
    updatedFinalData[index] = updatedData;
    setData(updatedFinalData);
  };

  const renderInvoices = (invoiceType: string) => {
    const invoices =
      (data?.data as Record<string, GstrTwoAInvoiceDataType[]>)[invoiceType] ||
      [];
    return invoices?.map((singleData: GstrTwoAInvoiceDataType) => {
      return (
        <React.Fragment key={singleData.invoice_number}>
          <tr>
            {tableHeader.map((header: TableHeadersType) => {
              if (
                header.value === "" &&
                singleData?.itemData &&
                singleData?.itemData?.length > 0
              ) {
                return (
                  <td key={header.value}>
                    {singleData.isOpen ? (
                      <img
                        width="20px"
                        onClick={() =>
                          handleClick(singleData.invoice_number!, invoiceType)
                        }
                        style={{ cursor: "pointer" }}
                        src={CollapseOpen}
                        className="accordion-arrow"
                        alt="collapse-icon"
                      />
                    ) : (
                      <img
                        width="20px"
                        onClick={() =>
                          handleClick(singleData.invoice_number!, invoiceType)
                        }
                        style={{ cursor: "pointer" }}
                        src={CollapseClose}
                        className="accordion-arrow"
                        alt="collapse-icon"
                      />
                    )}
                  </td>
                );
              }
              if (header.value == "compare" && showMissingInvoices) {
                return (
                  <td key={header.value}>
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        handleCompareAddInvoice(
                          singleData.invoice_number
                            ? singleData.invoice_number
                            : "",data?.month_name
                        );
                      }}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Create Invoice
                    </button>
                  </td>
                );
              }
              if (header.value === "place_of_supply") {
                const state = STATES_LIST_WITH_CODE.find(
                  (item) =>
                    item.label.slice(0, 2) ===
                    singleData[header.value as keyof GstrTwoAInvoiceDataType]
                );
                return <td key={header.value}>{state?.label}</td>;
              } else {
                return (
                  <td key={header.value}>
                    {singleData[
                      header.value as keyof GstrTwoAInvoiceDataType
                    ] === "Y"
                      ? "Yes"
                      : singleData[
                          header.value as keyof GstrTwoAInvoiceDataType
                        ] === "N"
                      ? "No"
                      : singleData[
                          header.value as keyof GstrTwoAInvoiceDataType
                        ]}
                  </td>
                );
              }
            })}
          </tr>

          {singleData.isOpen && (
            <>
              <tr style={{ borderBottom: "hidden", backgroundColor: "white" }}>
                <td
                  style={{ padding: "10px 0 0 0", backgroundColor: "white" }}
                ></td>
                <td
                  colSpan={tableHeader.length}
                  style={{
                    padding: "10px 0 0 0",
                    backgroundColor: "white",
                    textAlign: "left",
                  }}
                >
                  <h6>Item Details</h6>
                </td>
              </tr>

              <tr>
                <td style={{ padding: "0", backgroundColor: "white" }}></td>
                <td
                  colSpan={tableHeader.length}
                  style={{ padding: "0", backgroundColor: "white" }}
                >
                  <ItemDataTable
                    itemHeader={GSTR2A2B_ITEM_HEADER}
                    itemData={singleData.itemData || []}
                  />
                </td>
              </tr>
            </>
          )}
        </React.Fragment>
      );
    });
  };

  return (
    <>
      {[
        "b2b_invoices",
        "b2ba_invoices",
        "cdn_invoices",
        "cdna_invoices",
        "impg_invoices",
        "impgsez_invoices",
        "isd_invoices",
        "tcs_invoices",
        "tds_invoices",
      ].map((invoiceType) => {
        const totalKey = `${invoiceType.replace("_invoices", "_totals")}`;

        const totalValueKey = `total_${invoiceType.replace(
          "_invoices",
          "_invoice_value"
        )}`;
        const totalValue =
          data?.data?.total_values_data?.[totalKey]?.[totalValueKey];

        if (
          data?.data[invoiceType as keyof GstrTwoADataType] &&
          data?.data[invoiceType as keyof GstrTwoADataType]!.length > 0
        ) {
          return (
            <React.Fragment key={invoiceType}>
              <tr
                style={{
                  backgroundColor: "#f4f6f8",
                  borderTop: "solid 1px rgba(191, 203, 225, 0.6)",
                }}
              >
                <td colSpan={tableHeader.length}>
                  <h6 style={{ whiteSpace: "nowrap", margin: 0 }}>
                    {invoiceType.replace(/_/g, " ").toUpperCase()}
                  </h6>
                </td>
              </tr>

              {data?.data?.total_values_data ? (
                <tr
                  style={{
                    backgroundColor: "#f4f6f8",
                    borderTop: "solid 1px rgba(191, 203, 225, 0.6)",
                  }}
                >
                  {tableHeader?.map((el, index) => {
                    if (el?.value == "") {
                      return (
                        <td key={index}>
                          <h6 style={{ whiteSpace: "nowrap", margin: 0 }}>
                            Total
                          </h6>
                        </td>
                      );
                    } else if (el?.value === "total_invoice_value") {
                      return (
                        <td key={index}>
                          <strong>{totalValue}</strong>
                        </td>
                      );
                    } else {
                      return <td key={index}></td>;
                    }
                  })}
                </tr>
              ) : (
                ""
              )}

              {renderInvoices(invoiceType)}
            </React.Fragment>
          );
        }
        return null;
      })}
    </>
  );
};

export default GstrTwoATableData;
